var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style) {
buf.push("<img v-attr=\"src:image\" title=\"{{ store.login }}\"><div" + (jade.cls([style.container], [true])) + "><a href=\"/account/\" v-text=\"store.name_expeditor || 'Личный кабинет'\"" + (jade.cls([style.link], [true])) + "></a><div v-if=\"store.summa\"" + (jade.cls([style.summa], [true])) + ">{{ -1 * store.summa | currency '' }} р.</div><ul v-if=\"store.name_expeditor\"" + (jade.cls([style.menu], [true])) + "><li v-repeat=\"links\"><a href=\"/account/{{* name }}\" data-name=\"{{* name }}\" v-on=\"click: onClick\">{{* text }}</a></li></ul></div>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/menu-account/template.jade
 ** module id = 207
 ** module chunks = 0
 **/